import React from 'react';
import './LinkTitleNote.css';

/**
 * What a link really is, said in words before it is saved
 * (useYoutubeLinkTitle). A mismatch is a warning the teacher reads, never a
 * block. Plain elements, always visible: no hover, no colour alone.
 */
const LinkTitleNote = ({ info, songName }) => {
	if (!info || info.status === 'idle') return null;
	if (info.status === 'loading') {
		return <p className="ltn ltn--quiet" role="status">Checking which video this is…</p>;
	}
	if (info.status === 'unknown') {
		return (
			<p className="ltn ltn--quiet" role="status">
				Could not read this video's title. Open it to check it is the right song.
			</p>
		);
	}
	return (
		<div className={`ltn${info.mismatch ? ' ltn--warn' : ''}`} role="status">
			<p className="ltn__line">
				<i className={`fa-sharp fa-solid ${info.mismatch ? 'fa-triangle-exclamation' : 'fa-circle-check'}`} aria-hidden="true" />
				<span>
					This video is <strong>{info.title}</strong>
					{info.channel ? <span className="ltn__channel"> · {info.channel}</span> : null}
				</span>
			</p>
			{info.mismatch && (
				<p className="ltn__warn">
					Its title does not mention “{songName}”. Check it is the right song before you use it.
				</p>
			)}
		</div>
	);
};

export default LinkTitleNote;
